import * as Yup from "yup";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import EditIcon from "@mui/icons-material/Edit";

import React, { useState , useEffect } from "react";
import InfoIcon from "@mui/icons-material/Info";
import { useNavigate } from "react-router-dom";
// form
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
// @mui
import { responsiveValue } from "../../../theme/Styles/responsiveValue";

import {
  Link,
  Stack,
  IconButton,
  InputAdornment,
  Alert,
  Snackbar,
  Radio,
  Paper,
  Typography,
  Divider,
  Box,
  Autocomplete,
  TextField,
  Button,
  Grid,
} from "@mui/material";

import { LoadingButton } from "@mui/lab";
// components

import { FormProvider, RHFTextField } from "../../../components/hook-form";

//redux
import { useDispatch, useSelector } from "react-redux";

import { AddressData } from "../../../common/enum/addressData";
import {
  addUserAddress,
  addUserDetail,
} from "../../../Containers/OnBoarding/slice";
import {
  setSnackbarMessage,
  setSnackbarOpen,
  setSnackbarSeverity,
} from "../../../Containers/AdminView/adminSlice";
import {
  getUserEntity,
  getChildEntitiesList,
} from "../../../redux/features/authSlice";
import { useSnackbar } from "notistack";
import MapLeaflet from "../../../Containers/MapLeaflet";
import { RegistrationStatus } from "../../../common/enum";
import { replaceAllIcon } from "@progress/kendo-svg-icons";

const AddressForm = ({
  t,
  setBlock,
  block,
  details,
  setDetails,
  address,
  entity,
  editFromEstablishment,
  establishmentEntityId,
  refreshDetails,
}) => {
  const [showError, setShowError] = useState(null);
  const [editAddress, setEditAddress] = useState(false);
  const {
    addressTitle,
    phone,
    email,
    county,
    district,
    postalCode,
    subDivision,
    locality,
    addressLine,
    id,
    addressId,
    latitude,
    longitude,
  } = address || {};
  const { entityName, nic, entityId } = entity || {};

  const { auth, onBoarding } = useSelector((state) => state);


  const { bannerUri, profileUri } = onBoarding || {};

  const {
    auth: {
      user: { userId ,status ,managerName , managerEmail} = auth.user || {},
      branchEntitiesOffset,
      branchEntitiesLimit,
    } = {},
  } = useSelector((state) => state);
  const [select1, setSelect1] = useState(district || null);
  const [select2, setSelect2] = useState(county || null);
  const [select3, setSelect3] = useState(subDivision || null);
  const [position, setPosition] = useState({
    lat: 38.736946,
    lng: -9.142685,
  });
  const [positionError, setPositionError] = useState(false);
  React.useEffect(() => {
    if (editAddress) {
      setPosition({ lat: latitude, lng: longitude });
    }
  }, [editAddress]);

  const dispatch = useDispatch();

  const addAddressSchema = Yup.object().shape({
    
    NIF_NIPC: Yup.string().required(
      "O campo NIF / NIPC é de preenchimento obrigatório"
    )
    .length(9, "NIF / NIPC tem que ter 9 dígitos"),
    name: Yup.string().required("Name é de preenchimento obrigatório"),
    addressLine1: Yup.string().required(`${t("address")} é de preenchimento obrigatório `),
    houseHold: Yup.string().required(`${t("address")} é de preenchimento obrigatório `),
    postalCode1: Yup.string()
      .required(`${t("postcard")} é de preenchimento obrigatório`)
      .matches(/^[0-9]+$/, "Must be only digits")
      .min(4, "Must be exactly 4 digits")
      .max(4, "Must be exactly 4 digits"),
    postalCode2: Yup.string()
      .required(`${t("postcard")} é de preenchimento obrigatório `)
      .matches(/^[0-9]+$/, "Must be only digits")
      .min(3, "Must be exactly 3 digits")
      .max(3, "Must be exactly 3 digits"),
    locality: Yup.string().required(`${t("locality")} é de preenchimento obrigatório `),

    email: Yup.string()
      .email()
      .required(`${t("email")} é de preenchimento obrigatório`),
      phone: Yup.string()
      .required(`O campo ${t("phone")} é de preenchimento obrigatório`)
      .matches(/^(\+[\d]{1,5}|0)?[0-9]+$/, "devem ser apenas números")
      .min(9, 'O campo contato telefónico deve ter no mínimo 9 dígitos')
      .max(12, 'O campo contato telefónico deve ter no máximo 12 dígitos'),
  });
  const { enqueueSnackbar } = useSnackbar();
  const defaultValues = {
    NIF_NIPC: nic,
    name: managerName != null ? managerName :  entityName,
    addressLine1: addressTitle,
    postalCode1: postalCode.slice(0, 4),
    postalCode2: postalCode.slice(5),
    locality: locality,
    phone: phone,
    email: managerEmail != null ? managerEmail : email,
    houseHold: addressLine,
  };

  const methods = useForm({
    resolver: yupResolver(addAddressSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const setMarkerSDefaultPosition = (value) => {
    setPosition(value);
    setPositionError(false);
  };

  const onSubmit = async (data, e) => {
    e.preventDefault();
    const addressPayload = {
      addressId: addressId,
      id: id,
      entityId: editFromEstablishment ? establishmentEntityId : entityId,
      addressTitle: data.addressLine1,
      addressLine: data.houseHold,
      district: select1,
      county: select2,
      subDivision: select3,
      postalCode: `${data.postalCode1}-${data.postalCode2}`,
      locality: data.locality,
      latitude: position.lat,
      longitude: position.lng,
      phone: data.phone,
      email: data.email,
      isHeadquarter: address.isHeadquarter,
      isExternal: address.isExternal,
      updatedBy: entityId,
    };
    const updateEntity = {
      ...entity,
      entityName: data.name,
      nic: data.NIF_NIPC,
    };
    await dispatch(addUserAddress(addressPayload))
      .unwrap()
      .then((resAddress) => {
        dispatch(addUserDetail(updateEntity))
          .unwrap()
          .then(() => {
            dispatch(getUserEntity(entityId))
              .unwrap()
              .then(() => {
                enqueueSnackbar({
                  variant: "success",
                  message: t("successfullyUpdateAddress"),
                });
                if (refreshDetails) {
                  refreshDetails();
                }
                // setEditAddress(false);
              });
          });
      })
      .catch((error) => {
        enqueueSnackbar({
          variant: "error",
          message: t("unableToUpdateAddress"),
        });
        //console.log(error);
      });
  };
  const handledSubmit = async (e) => {
    e.preventDefault();
    await handleSubmit(onSubmit)(e);
  };


const fetchCoordinates = async (address) => {
  try {
    address = address.replaceAll(".", "");
    const response = await fetch(
      `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(address)}`
    );
    const data = await response.json();
    if (data && data.length > 0) {
      setPosition({
        lat: parseFloat(data[0].lat),
        lng: parseFloat(data[0].lon),
      });
      setPositionError(false);
    }
  } catch (err) {
    console.error("Erro ao buscar coordenadas:", err);
    setPositionError(true);
  }
};
const buildFullAddress = (data, select1, select2, select3) => {
  const parts = [
    data.houseHold,
    `${data.postalCode1}-${data.postalCode2}`,
    data.locality,
    select3,   // freguesia
    select2,   // concelho
    select1,   // distrito
  ];

  // Remove vazios e duplicados mantendo a ordem
  return [...new Set(parts.filter(Boolean))].join(", ");
};




useEffect(() => {
  if (editAddress) {
  const fullAddress = buildFullAddress(methods.getValues(), select1, select2, select3);
fetchCoordinates(fullAddress);
  }
}, [editAddress, select1, select2, select3]);






  return (
    <>
     <Paper
              variant="outlined"
              sx={{
                display: "flex",
                flexDirection: "column",
                p: 1,
              }}
            >
      {managerName == null && <Stack direction={"row"} justifyContent="end">
        <Button
          onClick={() => setEditAddress(true)}
          startIcon={<EditIcon />}
          variant="contained"
          sx={{ borderRadius: "4px" }}
          disabled={
            status === RegistrationStatus.inActive ||
            status === RegistrationStatus.inAtivo ||
            status === RegistrationStatus.revoked
          }
        >
          {t("edit")}
        </Button>
      </Stack>}
      {editAddress ? (
        <Grid
          marginTop="20px"
          container
          spacing={responsiveValue("", "", "", "2", "2", "0")}
          direction={responsiveValue(
            "",
            "",
            "",
            "row",
            "row",
            "column-reverse"
          )}
          justifyContent={"space-evenly"}
        >
          <Grid item marginTop={responsiveValue("", "", "", "0", "0", "90px")}>
            <FormProvider methods={methods} onSubmit={handledSubmit}>
              <Stack spacing={3}>
                <Paper sx={{ padding: "20px" }}>
                  <Typography>Identificação</Typography>

                  <RHFTextField
                    id="outlined-basic"
                    label="NIF/ NIPC*"
                    variant="outlined"
                    name="NIF_NIPC"
                    sx={{ marginTop: "20px" }}
                    fullWidth
                    hidden={editFromEstablishment}
                    inputProps={{ maxLength: 9 }}
                    disabled
                  />

                  <RHFTextField
                    id="outlined-basic"
                    label={t("name")+ "*"}
                    variant="outlined"
                    name="name"
                    sx={{ marginTop: "20px" }}
                    fullWidth
                    hidden={editFromEstablishment}
                    disabled
                  />
                  <RHFTextField
                    id="outlined-basic"
                    label={t("addressTitle")+ "*"}
                    variant="outlined"
                    name="addressLine1"
                    sx={{ marginTop: "20px" }}
                    
                    fullWidth
                  />
                  <RHFTextField
                    id="outlined-basic"
                    label={t("houseHold")+ "*"}
                    variant="outlined"
                    name="houseHold"
                    sx={{ marginTop: "20px" }}
                    onBlur={() => {
                        const fullAddress = buildFullAddress(methods.getValues(), select1, select2, select3);
                        fetchCoordinates(fullAddress);
                    }}
                    fullWidth
                  />
                  <RHFTextField
                    id="outlined-basic"
                    label={t("phone")+ "*"}
                    variant="outlined"
                    name="phone"
                    sx={{ marginTop: "20px" }}
                    fullWidth
                    inputProps={{ maxLength: 12 }}
                  />
                  <RHFTextField
                    id="outlined-basic"
                    label={t("emailAddress")+ "*"}
                    variant="outlined"
                    name="email"
                    sx={{ marginTop: "20px" }}
                    fullWidth
                    disabled={editFromEstablishment}
                  />

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      flexDirection: responsiveValue(
                        "",
                        "",
                        "",
                        "row",
                        "row",
                        "column"
                      ),
                    }}
                  >
                    <Autocomplete
                      value={select1 ? select1  : district?.district}
                      noOptionsText={t("noOptionsText")}
                      disablePortal
                      defaultValue={
                        (address !== undefined &&
                          AddressData.find(
                            (item) => item.district === select1 ? select1  : district?.district
                          ).district) ||
                        ""
                      }
                      options={AddressData.map((item) => item.district).sort((a, b) => a.localeCompare(b, 'pt-PT'))}
                      //options={AddressData.map((item) => item.district)}
                      sx={{
                        width: responsiveValue(
                          "",
                          "",
                          "",
                          "32%",
                          "32%",
                          "100%"
                        ),
                        marginTop: "20px",
                      }}
                      isOptionEqualToValue={(option, value) => option === value}
                      onChange={(event, value) => {
                        setSelect1(value);
                        setSelect2(null);
                        setSelect3(null);
                      }}
                      onBlur={() => {
                        const fullAddress = buildFullAddress(methods.getValues(), select1, select2, select3);
                        fetchCoordinates(fullAddress);
                      }}
                      renderInput={(params) => (
                        <TextField
                          helperText={
                            !select1 && showError
                              ? `Pease Select Your ${t("district")}.`
                              : null
                          }
                          error={showError && !select1}
                          {...params}
                          label={t("district")+ "*"}
                        />
                      )}
                    />
                    <Autocomplete
                      noOptionsText={t("noOptionsText")}
                      disablePortal
                     defaultValue={
                        AddressData.find(item => item?.district === select1)
                          ?.county.find(item => item?.countyName === select2)
                          ?.countyName || ""
                      }
                      isOptionEqualToValue={(option, value) => option === value}
                     
                      options={
                        select1
                        ? AddressData.find(
                          ({ district }) => district === select1
                          ).county.map((county) => county.countyName).sort((a, b) => a.localeCompare(b, 'pt-PT'))
                        : []
                      }
                      sx={{
                        width: responsiveValue(
                          "",
                          "",
                          "",
                          "32%",
                          "32%",
                          "100%"
                        ),
                        marginTop: "20px",
                      }}
                      getOptionLabel={(option) => (option ? option : "")}
                      value={select2 !== null ? select2 : ""}
                      onChange={(event, value) => setSelect2(value)}
                      renderInput={(params) => (
                        <TextField
                          helperText={
                            !select2 && showError
                              ? `Pease Select Your ${t("county")}.`
                              : null
                          }
                          error={showError && !select2}
                          {...params}
                          label={t("county")+ "*"}
                        />
                      )}
                    />

                    <Autocomplete
                      noOptionsText={t("noOptionsText")}
                      disablePortal
                      // defaultValue={
                      //   (address !== undefined &&
                      //     AddressData.find((item) => item?.district === select1)
                      //       ?.county.find((item) => item?.countyName === select2)
                      //       ?.fregusias.find(
                      //         (item) => item?.freguesiaName === select3
                      //       )?.freguesiaName) ||
                      //   ""
                      // }
                      defaultValue={
                        AddressData.find(item => item?.district === select1)
                          ?.county.find(item => item?.countyName === select2)
                          ?.fregusias.find(item => item?.freguesiaName === select3)
                          ?.freguesiaName || ""
                      }
                      onBlur={() => {
                        const fullAddress = buildFullAddress(methods.getValues(), select1, select2, select3);
                        fetchCoordinates(fullAddress);
                    }}
                      isOptionEqualToValue={(option, value) => option === value}
                      // options={
                      //   select2
                      //   ? AddressData.find(({ district }) => district === select1)
                      //     ?.county.find(({ countyName }) => countyName === select2)
                      //     .fregusias.map((subDivision) => subDivision.freguesiaName).sort((a, b) => a.localeCompare(b, 'pt-PT'))
                      //   : []
                      // }
                      options={
                        select2
                          ? (
                              AddressData.find(({ district }) => district === select1)
                                ?.county.find(({ countyName }) => countyName === select2)
                                ?.fregusias?.map(subDivision => subDivision.freguesiaName)
                                ?.sort((a, b) => a.localeCompare(b, "pt-PT"))
                            ) || []
                          : []
                      }
                      // options={
                      //   select2
                      //     ? AddressData.find(
                      //         ({ district }) => district === select1
                      //       )
                      //         ?.county.find(
                      //           ({ countyName }) => countyName === select2
                      //         )
                      //         .fregusias.map(
                      //           (subDivision) => subDivision.freguesiaName
                      //         )
                      //     : []
                      // }
                      sx={{
                        width: responsiveValue(
                          "",
                          "",
                          "",
                          "32%",
                          "32%",
                          "100%"
                        ),
                        marginTop: "20px",
                      }}
                      value={select3 !== null ? select3 : ""}
                      onChange={(event, value) => setSelect3(value)}
                      getOptionLabel={(option) => (option ? option : "")}
                      renderInput={(params) => (
                        <TextField
                          helperText={
                            !select3 && showError
                              ? `Pease Select Your ${t("parshi")}.`
                              : null
                          }
                          error={showError && !select3}
                          {...params}
                          label={t("parshi")+ "*"}
                        />
                      )}
                    />
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      flexDirection: responsiveValue("", "", "", "", "", "row"),
                    }}
                  >
                    <Box
                      sx={{
                        width: "40%",
                        display: "flex",
                        marginTop: "20px",
                        alignItems: "center",
                      }}
                    >
                      <RHFTextField
                        id="outlined-basic"
                        label={t("postcard")+ "*"}
                        name="postalCode1"
                        variant="outlined"
                        sx={{ width: "50%" }}
                        inputProps={{ maxLength: 4 }}
                        onBlur={() => {
                        const fullAddress = buildFullAddress(methods.getValues(), select1, select2, select3);
                        fetchCoordinates(fullAddress);
                    }}
                      />
                      <Box
                        sx={{
                          width: "17px",
                          height: "2px",
                          background: "gray",
                          marginX: "5px",
                        }}
                      >
                        {" "}
                      </Box>

                      <RHFTextField
                        id="outlined-basic"
                        variant="outlined"
                        name="postalCode2"
                        sx={{ width: "50%" }}
                        // label="postal"
                        className="noLabel"
                        inputProps={{ maxLength: 3 }}
                        onBlur={() => {
                        const fullAddress = buildFullAddress(methods.getValues(), select1, select2, select3);
                        fetchCoordinates(fullAddress);
                    }}
                      />
                    </Box>

                    {/* 2 */}

                    <Box
                      sx={{
                        width: "58%",
                      }}
                    >
                      <RHFTextField
                        id="outlined-basic"
                        label={t("locality")+ "*"}
                        variant="outlined"
                        name="locality"
                        sx={{ marginTop: "20px" }}
                        fullWidth
                        onBlur={() => {
                        const fullAddress = buildFullAddress(methods.getValues(), select1, select2, select3);
                        fetchCoordinates(fullAddress);
                    }}
                      />
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      width: 1,
                      backgroundColor: "#e5f1ff",
                      display: "flex",
                      alignItems: "center",
                      borderRadius: 1.5,
                      p: 1.5,
                      my: 2,
                    }}
                  >
                    <InfoIcon sx={{ color: "#0167d6" }} />
                    <Typography variant="body2" fontWeight={500} mx={2}>
                      {`${t("mapInfo")}`}
                    </Typography>
                  </Box>
                  <Box sx={{ width: 1, height: 400, py: 1 }}>
                    <MapLeaflet
                      isDirectionAble={false}
                      isSearchAble={true}
                      position={position}
                      setPosition={setMarkerSDefaultPosition}
                      t={t}
                      onAddressFound={(addr) => {
                        methods.setValue("houseHold", `${addr.road || ""} ${addr.house_number || ""}`.trim());
                        methods.setValue("postalCode1", addr.postcode ? addr.postcode.split("-")[0] : "");
                        methods.setValue("postalCode2", addr.postcode ? addr.postcode.split("-")[1] : "");
                        methods.setValue("locality", addr.city || addr.town || addr.village || "");
                        // Distrito pelo código ISO
                      const isoNumber = parseInt(addr["ISO3166-2-lvl6"].split("-")[1], 10);

                        // encontra o distrito
                        const districtOption = AddressData.find(d => d.code === isoNumber);
                        setSelect1(districtOption?.district || addr.city || county|| "");    // distrito
                        console.log(AddressData)
                        // Concelho
                        const countyOption = districtOption?.county.find(c => c.countyName === addr.county);
                        setSelect2(countyOption?.countyName || addr.county || "");

                        // Freguesia
                        const subDivisionOption = countyOption?.fregusias.find(f => f.freguesiaName === addr.village || addr.neighbourhood);
                        setSelect3(subDivisionOption?.freguesiaName || addr.city_district || addr.suburb || addr.town || "" );
                      }}
                    />
                    {positionError && (
                      <Typography variant="subtitle2" color="error" py={1}>
                        {t("selectYourPosition")}
                      </Typography>
                    )}
                  </Box>
                  <Stack
                    direction={"row"}
                    justifyContent={"space-between"}
                    marginTop={2}
                  >
                    <Button
                      onClick={() => setEditAddress(false)}
                      sx={{
                        background: "#FFEEEE",
                        color: "#FF0000",
                        padding: "8px 22px",
                        borderRadius: "4px",
                        "&:hover": { background: "#FF0000", color: "#FFEEEE" },
                      }}
                    >
                      {t("cancel")}
                    </Button>
                    <LoadingButton
                      sx={{
                        borderRadius: "4px",
                      }}
                      size="large"
                      type="submit"
                      variant="contained"
                    >
                      {t("toSave")}
                    </LoadingButton>
                  </Stack>
                </Paper>
              </Stack>
            </FormProvider>
          </Grid>
        </Grid>
      ) : (
       
        <Stack mt={2} direction={"column"} gap={1} width={1}>
          <Stack
            direction={"column"}
            alignItems="left"
            justifyContent={"space-between"}
            width={1}
            hidden={editFromEstablishment}
            fontSize={15}
          >
            <Typography variant="h4" style={{fontSize:"14px"}}>NIF/NIPC</Typography>
            <Typography sx={{ marginTop: "5px", marginBottom: "5px" , fontSize:"14px"}}>
              {nic}
            </Typography>
          </Stack>
          <Stack
            direction={"column"}
            alignItems="left"
            justifyContent={"space-between"}
            width={1}
            hidden={editFromEstablishment}
            fontSize={15}
          >
            <Typography variant="h4" style={{fontSize:"14px"}}>{t("name")}</Typography>
            <Typography sx={{ marginTop: "5px", marginBottom: "5px" ,fontSize:"14px"}}>
              {managerName != null ? managerName :  entityName}
            </Typography>
          </Stack>
          <Stack
            direction={"column"}
            alignItems="left"
            justifyContent={"space-between"}
            width={1}
          >
            <Typography variant="h4" style={{fontSize:"14px"}}>{t("addressTitle")}</Typography>
            <Typography sx={{ marginTop: "5px", marginBottom: "5px", fontSize:"14px" }}>
              {addressTitle}
            </Typography>
          </Stack>
          <Stack
            direction={"column"}
            alignItems="left"
            justifyContent={"space-between"}
            width={1}
          >
            <Typography variant="h4" style={{fontSize:"14px"}}>{t("houseHold")}</Typography>
            <Typography sx={{ marginTop: "5px", marginBottom: "5px", fontSize:"14px" }}>
              {addressLine}
            </Typography>
          </Stack>
          <Stack
            direction={"column"}
            alignItems="left"
            justifyContent={"space-between"}
            width={1}
          >
            <Typography variant="h4" style={{fontSize:"14px"}}>{t("phone")}</Typography>
            <Typography sx={{ marginTop: "5px", marginBottom: "5px", fontSize:"14px" }}>
              {phone}
            </Typography>
          </Stack>
          <Stack
            direction={"column"}
            alignItems="left"
            justifyContent={"space-between"}
            width={1}
          >
            <Typography variant="h4" style={{fontSize:"14px"}}>{t("email")}</Typography>
            <Typography sx={{ marginTop: "5px", marginBottom: "5px" , fontSize:"14px"}}>
              {managerEmail != null ? managerEmail : email}
            </Typography>
          </Stack>
          <Stack
            direction={"column"}
            alignItems="left"
            justifyContent={"space-between"}
            width={1}
          >
            <Typography variant="h4" style={{fontSize:"14px"}}>{t("district")}</Typography>
            <Typography sx={{ marginTop: "5px", marginBottom: "5px" , fontSize:"14px"}}>
              {district}
            </Typography>
          </Stack>
          <Stack
            direction={"column"}
            alignItems="left"
            justifyContent={"space-between"}
            width={1}
          >
            <Typography variant="h4" style={{fontSize:"14px"}}>{t("county")}</Typography>
            <Typography sx={{ marginTop: "5px", marginBottom: "5px" , fontSize:"14px"}}>
              {county}
            </Typography>
          </Stack>
          <Stack
            direction={"column"}
            alignItems="left"
            justifyContent={"space-between"}
            width={1}
          >
            <Typography variant="h4" style={{fontSize:"14px"}}>{t("parshi")}</Typography>
            <Typography sx={{ marginTop: "5px", marginBottom: "5px", fontSize:"14px" }}>
              {subDivision}
            </Typography>
          </Stack>
          <Stack
            direction={"column"}
            alignItems="left"
            justifyContent={"space-between"}
            width={1}
          >
            <Typography variant="h4" style={{fontSize:"14px"}}>{t("postalCode")}</Typography>
            <Typography sx={{ marginTop: "5px", marginBottom: "5px" , fontSize:"14px"}}>
              {postalCode}
            </Typography>
          </Stack>
          <Stack
            direction={"column"}
            alignItems="left"
            justifyContent={"space-between"}
          >
            <Typography variant="h4" style={{fontSize:"14px"}}>{t("locality")}</Typography>
            <Typography sx={{ marginTop: "5px", marginBottom: "5px" , fontSize:"14px"}}>
              {locality}
            </Typography>
          </Stack>
        </Stack>

      )}
      </Paper>
    </>
    
  );
};

export default AddressForm;
